import { DesktopOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons"
import { Segmented } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { APPEARANCE_MODES, type AppearanceMode } from "./appearance-preference"
import { useAppearance } from "./use-appearance"

const ICONS: Record<AppearanceMode, React.ReactNode> = {
  light: <SunOutlined aria-hidden />,
  dark: <MoonOutlined aria-hidden />,
  system: <DesktopOutlined aria-hidden />
}

/** The profile menu's three-way switch; applies on change, no Save. */
export function AppearanceSwitch() {
  const { t } = useTranslation()
  const { mode, setMode } = useAppearance()

  return (
    <Segmented<AppearanceMode>
      block
      size="small"
      aria-label={t("appearance.groupLabel")}
      value={mode}
      onChange={setMode}
      options={APPEARANCE_MODES.map((value) => ({
        value,
        icon: ICONS[value],
        label: t(`appearance.${value}`)
      }))}
    />
  )
}
